import { connect } from 'react-redux';

import { MapStateToProps } from '~commonInfra/utils/ConnectUtils';
import { SessionSiteSelectors } from '~src/bootstrap/redux/selectors/SessionInfoSelectors';

import { AppState } from '../../../bootstrap/redux/state/AppState';
import { DetailedDatasourceThumbnail, DetailedDatasourceThumbnailStateProps } from './DetailedDatasourceThumbnail';

const mapStateToProps: MapStateToProps<DetailedDatasourceThumbnailStateProps> = (state: AppState) => {
  return {
    siteEARMode: SessionSiteSelectors.extractEncryptionMode(state)
  };
};

export const ConnectedDetailedDatasourceThumbnail = connect(mapStateToProps)(DetailedDatasourceThumbnail);
